import React from "react";
import "./InventorySettingsRow.css";
import { IReducer } from "../../state/reducer";

interface InventorySettingsRowProps extends IReducer {
  id: string;
  name: string;
  type: "Brick" | "Plate" | "Slope" | "Minifig" | "Bionicle" | "Animal";
  userHidden: boolean;
}

const InventorySettingsRow: React.FC<InventorySettingsRowProps> = ({
  id,
  name,
  type,
  userHidden,
  dispatch,
}) => {
  const handleToggle = () => {
    dispatch({
      type: "TOGGLE_BRICK_USER_VISIBILITY",
      brickId: id,
    });
  };

  return (
    <div className="noSelect inventorySettingsRowContainer">
      <div className="inventorySettingsRowContent">
        <div className="inventorySettingsRowHeader">
          <span className="inventorySettingsRowType">{type}</span>
          <div className="inventorySettingsRowName">{name}</div>
        </div>
        <div className="inventoryToggleButtonContainer">
          <button
            className={`inventoryToggleButton ${userHidden ? "inventoryToggleOff" : "inventoryToggleOn"}`}
            onClick={handleToggle}
          >
            {userHidden ? "Hidden" : "Visible"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InventorySettingsRow;
